import React, { Component } from 'react';
import { getApp } from './listener';
import Hotkeys from "react-hot-keys";
import { COLORS } from '../../pages/theme';



let keyToListen = 'Alt';
let lastKeyUpAt = 0;
let HOLD_DURATION = 100; //in ms


class KeyboardShortcutWrapper extends Component {
    constructor(props) {
        super(props)

        this.state = {
            holded: false
        }
        // this.handleKeyUp=this.handleKeyUp.bind(this);
        // this.handleKeydown=this.handleKeydown.bind(this);

    }

    onKeyDown(keyName, e, handle) {
       
        console.log("key down started");
        this.setState({
            holded:false
        })
        lastKeyUpAt = new Date();
        typeof this.props.onDown==='function'&&this.props.onDown();
      }

    render() {
        let wrapperStyle=this.props.wrapperStyle||{};
        let label=this.props.label;
        let _combination=this.props.trigger||"Alt+1"
        let showHelper=true;//this.props.showHelper
        let customChildNode=(l)=>{
            return <><div className='keyboard-shortcut-indicator ' style={{
            }}></div>
            <div className='hint-label'>{l}</div>
            </>
        };

        // let customChildNode=(l)=>{
        //     return <><div className='keyboard-shortcut-indicator2' style={{
        //     }}>{l}</div>
        //     </>
        // };
        // this.props.renderChildNode

        return (
            <Hotkeys
            keyName={_combination}
            onKeyDown={this.onKeyDown.bind(this)}
            filter={event => true}
          >
            <div style={{
                position:'relative',
                height:'inherit',
                ...wrapperStyle
            }}>{this.props.children}
            {this.state.holded&&customChildNode(label)}
            </div>
            </Hotkeys>
        );
    }

    handleKeydown = (e) => {
        var keyDownAt = new Date();
        console.log("ke", e,this.props.trigger)

        let ctx = this;
        setTimeout(function () {
            // Compare key down time with key up time
            if (+keyDownAt > +lastKeyUpAt && e.key == keyToListen) {
                // Key has been held down for x seconds
                ctx.setState({
                    holded: true
                })
            }
            else {
                // Key has not been held down for x seconds
                ctx.setState({
                    holded:false
                })
            }
        }, HOLD_DURATION);

    }
    handleKeyUp = () => {
        lastKeyUpAt = new Date();
        this.setState({
            holded: false
        })

    }


    componentDidMount() {

        this.keyUpKey = 1;
        this.keyDownKey=1;
        let app=getApp();
        this.keyDownKey = app.keydown.subscribe(this.handleKeydown)
        this.keyUpKey = app.keyup.subscribe(this.handleKeyUp)
        // window.addEventListener('keydown', this.handleKeydown)
        // window.addEventListener('keyup', this.handleKeyUp);

    }

    componentWillUnmount() {
        let app=getApp();
        app.keydown.unsubscribe(this.keyDownKey);
        app.keyup.unsubscribe(this.keyUpKey);
        // window.removeEventListener('keydown', this.handleKeydown)
        // window.removeEventListener('keyup', this.handleKeyUp);
    }
}
export default KeyboardShortcutWrapper


